import { Alert, AlertTitle, Box, Button, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

/**
 * Combo de integração vazio no editor de forma de pagamento.
 *
 * O cadastro da integração (com a chave de API) mora no Sischef, não aqui — o
 * cardápio só vincula. Sem esse aviso o gestor via um combo vazio, sem forma de
 * descobrir que faltava um cadastro em OUTRO sistema, e o botão salvar
 * simplesmente não habilitava.
 */
export function AlertaSemIntegracaoPagamento({
  tipo,
  aoAtualizar,
}: {
  tipo: 'ONLINE' | 'TEF';
  aoAtualizar: () => void;
}): JSX.Element {
  const nome = tipo === 'TEF' ? 'TEF Elgin' : 'ASAAS';

  return (
    <Alert severity="warning" variant="outlined" sx={{ '& .MuiAlert-message': { width: '100%', minWidth: 0 } }}>
      <AlertTitle>Nenhuma integração {nome} cadastrada</AlertTitle>
      <Typography variant="body2">
        {tipo === 'TEF'
          ? 'A integração associa a loja ao app do TEF e é cadastrada no Sischef Retaguarda, não aqui.'
          : 'A integração guarda a chave de API da conta ASAAS da loja e é cadastrada no Sischef Retaguarda, não aqui.'}{' '}
        Enquanto ela não existir, esta forma de pagamento não pode ser salva. Para cadastrar:
      </Typography>

      <Box component="ol" sx={{ pl: 2.5, mt: 1, mb: 0, '& li': { mb: 0.75 }, typography: 'body2' }}>
        <li>
          No <b>Sischef Retaguarda</b>, abra o menu <b>Integrações → Configurações</b> e, no topo da tela, clique
          em <b>Listagem</b>.
        </li>
        <li>
          Clique em <b>Nova integração</b> e escolha o tipo <b>{nome}</b>.
        </li>
        {tipo === 'TEF' ? (
          <li>Dê uma descrição que identifique o equipamento (ex.: “TEF do totem”).</li>
        ) : (
          <li>
            Dê uma descrição (ex.: “ASAAS da loja”) e cole em <b>Chave de API (Token)</b> o token gerado na conta
            ASAAS da loja.
          </li>
        )}
        <li>
          Salve com a integração <b>ativa</b> e volte aqui — ela passa a aparecer no campo acima.
        </li>
      </Box>

      <Button size="small" startIcon={<RefreshIcon />} onClick={aoAtualizar} sx={{ mt: 1, px: 0 }} color="inherit">
        Já cadastrei — atualizar lista
      </Button>
    </Alert>
  );
}
